export const points = {
  Q1A1: 4,
  Q1A2: 2,
  Q1A3: 1,
  Q1A4: 0,
  Q1A5: 6,
  Q2A1: 2,
  Q2A2: 6,
  Q2A3: 4,
  Q2A4: 1,
  Q2A5: 0,
  Q3A1: 2,
  Q3A2: 2,
  Q3A3: 2,
  Q3A4: 6,
  Q3A5: 0,
  Q4A1: 2,
  Q4A2: 2,
  Q4A3: 2,
  Q4A4: 6,
  Q4A5: 0,
  Q5A1: 2,
  Q5A2: 2,
  Q5A3: 2,
  Q5A4: 2,
  Q5A5: 2,
  Q5A6: 0,
  Q6A1: 2,
  Q6A2: 2,
  Q6A3: 2,
  Q6A4: 2,
  Q6A5: 2,
  Q6A6: 2,
  Q6A7: 2,
  Q6A8: 2,
  Q6A9: 0,
  Q7A1: 6,
  Q7A2: 4,
  Q7A3: 1,
  Q7A4: 2,
  Q7A5: 0,
};

export const discovery_limit = 18;
export const experimentation_limit = 38;
export const adoption_limit = 57;

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30WatsonxOSA = '30AS5';
